// removed by extract-text-webpack-plugin
module.exports = {"paymentsWrap":"payments__paymentsWrap___3oMec","payments":"payments__payments___IWd1M","payment":"payments__payment___3cQl2","charge_back":"payments__charge_back___r4t-3","charge_back_reversed":"payments__charge_back_reversed___10Lkp","charge_back_reveresed":"payments__charge_back_reveresed___1JC8W","paid":"payments__paid___29Jah","late":"payments__late___CxLlf","paymentDate":"payments__paymentDate___2RnoP","next":"payments__next___3uDTl","paymentTop":"payments__paymentTop___3rf2k","paymentAmount":"payments__paymentAmount___pmFn3"};


//////////////////
// WEBPACK FOOTER
// ./src/components/payments/payments.scss
// module id = 1242
// module chunks = 0